import type { SerializedStyles } from "@emotion/react";
import type { ReactNode } from "react";

import { CountrySelect } from "@shared/components/CountrySelect/CountrySelect";
import { PlatformLogo } from "@shared/components/PlatformLogo/PlatformLogo";

import * as styles from "./FullBleedShell.styles";

interface Props {
  panel?: ReactNode;
  children: ReactNode;
  showCountrySelect?: boolean;
  showPlatformLogo?: boolean;
  afterContent?: ReactNode;
  customCss?: SerializedStyles;
}

const FullBleedShell = ({
  panel,
  children,
  showCountrySelect = false,
  showPlatformLogo = false,
  afterContent,
  customCss,
}: Props) => (
  <div css={[styles.fullBleedRow, customCss]}>
    {!!panel && <div css={styles.panelColumn}>{panel}</div>}
    <div css={styles.formColumn}>
      <div css={styles.formColumnInner}>
        {!!showCountrySelect && (
          <div css={styles.countrySelectRow}>
            <CountrySelect />
          </div>
        )}
        <div css={styles.formContent}>
          <div css={styles.formGroup}>
            {!!showPlatformLogo && (
              <div css={styles.logoContainer}>
                <PlatformLogo customCss={styles.logo} />
              </div>
            )}
            {children}
          </div>
          {afterContent}
        </div>
      </div>
    </div>
  </div>
);

export { FullBleedShell };
